import { lazy } from "react";
import Icon from "../../components/Icon";

const Ticketing = lazy(() => import("./Ticketing"));
const TicketList = lazy(() => import("./TicketList"));
const TicketDetail = lazy(() => import("./TicketDetail"));
const ComplaintList = lazy(() => import("./ComplaintList"));
const ComplaintDetail = lazy(() => import("./ComplaintDetail"));
const ComplaintNew = lazy(() => import("./ComplaintNew"));
const SlaRequest = lazy(() => import("./SlaRequest"));
const SlaRequestList = lazy(() => import("./SlaRequestList"));
const SlaRequestDetail = lazy(() => import("./SlaRequestDetail"));
const Relocation = lazy(() => import("./Relocation"));
const RegisterMobile = lazy(() => import("./RegisterMobile"));

let SupportRoutes = [
  {
    path: "/support/ticketing/:dealID?",
    pathSideBar: "/support/ticketing",
    exact: false,
    title: "ارسال تیکت جدید",
    sidebar: true,
    iconTag: <Icon name={"ticketing"} className={"drawerIcons large"} />,
    component: Ticketing,
    roles: ["LIMITED"],
  },
  {
    path: "/support/tickets-list",
    exact: false,
    title: "تیکت ها",
    sidebar: true,
    iconTag: <Icon name={"tickets"} className={"drawerIcons large"} />,
    component: TicketList,
    roles: ["GLOBAL"],
  },
  {
    path: "/support/ticket-detail/:id",
    exact: false,
    component: TicketDetail,
    roles: ["GLOBAL"],
  },
  {
    path: "/support/complaint",
    exact: true,
    title: "صدای مشتری",
    sidebar: true,
    iconTag: <Icon name={"complaint"} className={"drawerIcons large"} />,
    component: ComplaintList,
    roles: ["LIMITED"],
  },
  {
    path: "/support/complaint/new",
    title: "ثبت شکایت",
    component: ComplaintNew,
    roles: ["LIMITED"],
  },
  {
    path: "/support/complaint/:id",
    exact: true,
    title: "جزییات شکایت",
    component: ComplaintDetail,
    roles: ["LIMITED"],
  },
  {
    path: "/support/complaint/:id",
    exact: true,
    title: "جزییات درخواست",
    component: ComplaintDetail,
    roles: ["LIMITED"],
  },
  {
    path: "/support/sla-request/new",
    exact: true,
    title: "ثبت درخواست جدید",
    component: SlaRequest,
    roles: ["LIMITED"],
  },
  {
    path: "/support/sla-request/:id",
    exact: true,
    title: "SLA جزییات درخواست",
    component: SlaRequestDetail,
    roles: ["LIMITED"],
  },
  {
    path: "/support/sla-request",
    exact: true,
    sidebar: true,
    iconTag: <Icon name={"deposits-list"} className={"drawerIcons large"} />,
    title: "درخواست خسارت SLA",
    component: SlaRequestList,
    roles: ["LIMITED"],
  },
  {
    path: "/support/relocation-request",
    exact: true,
    sidebar: true,
    iconTag: <Icon name={"return-invoice"} className={"drawerIcons large"} />,
    title: "درخواست جابه‌جایی سرویس",
    component: Relocation,
    roles: ["LIMITED"],
  },
  {
    path: "/support/register-mobile",
    exact: true,
    title: "درخواست ثبت شماره موبایل",
    component: RegisterMobile,
    roles: ["GLOBAL"],
  },
];

export default SupportRoutes;
